import { createStore } from "vuex";
import authentication from "./modules/authentication.store";
import company from "./modules/company.store";
import estate from "./modules/estate.store";
import notification from "./modules/notification.store";
import partner from "./modules/partner.store";
import role from "./modules/role.store";
import user from "./modules/user.store";

export default createStore({
  state: {},
  mutations: {},
  actions: {
    clearAll({ commit }) {
      commit("authentication/resetState");
      commit("company/resetState");
      commit("estate/resetState");
      commit("notification/resetState");
      commit("partner/resetState");
      commit("role/resetState");
      commit("user/resetState");
    },
  },
  modules: {
    authentication,
    company,
    estate,
    notification,
    partner,
    role,
    user,
  },
});
